import React, { FC } from 'react';
import './ItvHeader.scss';
import MainLogo from './../../../assets/Itv/Win_White 1.svg';
import { BRANDS } from '../types';
import { joinStrings } from '../../../utils/string';

export interface ItvHeaderProps {
  variant?: BRANDS;
}

export const ItvHeader: FC<ItvHeaderProps> = ({ variant }) => {
  return (
    <header className={joinStrings(['itv-header', variant])}>
      <img src={MainLogo} alt="logo" className="itv-header__logo" />
    </header>
  );
};
